<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置车辆信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="driverName" label="密码">
        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
        <Button type="primary" @click="posswordTwo" style="margin-right: 5px;">密码2</Button>
        <Button type="primary" @click="passwordThree" style="margin-right: 5px;">密码3</Button>
        <Button type="primary" @click="passwordFour" style="margin-right: 5px;">密码4</Button>
        <Input v-model="setDriverCardParams.possword" type="password" password placeholder="请输入密码">
        </Input>
      </FormItem>
      <FormItem prop="registrationNum" label="车牌号">
        <Input v-model="setDriverCardParams.registrationNum" placeholder="请输入车牌号">
        </Input>
      </FormItem>
      <FormItem prop="vin" label="车架号">
        <Input v-model="setDriverCardParams.vin" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <FormItem prop="vehicleType" label="车辆类型">
<!--        <Input v-model="setDriverCardParams.vehicleType" placeholder="请输入车辆类型">-->
<!--        </Input>-->
        <Select placeholder="车辆类型"
                v-model="setDriverCardParams.vehicleType">
          <Option v-for="(option, index) in vehicleTypeOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="setDriverCardParams.vehicleType == 0" prop="vehicleType" label="自定义">
        <Input v-model="setDriverCardParams.customized" placeholder="请输入自定义">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'rmsetdrivervehicleinfomodal',
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        possword: 'admin',
        registrationNum: '',
        vin: '',
        vehicleType: '',
        customized: '',
      },
      vehicleTypeOptions:[
        {label:'自定义', value: '0'},
        {label:'出租车', value: '1'},
        {label:'校车', value: '2'},
        {label:'小型客车', value: '3'},
        {label:'中型客车', value: '4'},
        {label:'大型客车', value: '5'},
        {label:'小型货车', value: '6'},
        {label:'中型货车', value: '7'},
        {label:'大型货车', value: '8'},
        {label:'小型挂车', value: '9'},
        {label:'中型挂车', value: '10'},
        {label:'大型挂车', value: '11'},
        {label:'危险品运输车', value: '12'},
        {label:'未知车辆', value: '13'},
      ],

    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.registrationNum = ''
        this.setDriverCardParams.vin = ''
        this.setDriverCardParams.vehicleType = 0
        this.setDriverCardParams.customized = ''
          this.possworsOne()

          store.dispatch('PositioningDeviceInfoServ_SearchByName',{
              params:{
                  name: this._terminalNumValue
              },
              urlparams:null,
          }).then(res =>{
              if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
                  console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
                  let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
                  if (vehicleInfoId!=null){
                      store.dispatch('VehicleInfoServ_GetDetail',{
                          params:{
                              id: vehicleInfoId
                          },
                          urlparams:null
                      }).then(res =>{
                          if (store.getters.get_VehicleInfo_GetDetailResult){
                              let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                              this.setDriverCardParams.vin = vehicleInfo.vin
                              this.setDriverCardParams.registrationNum = vehicleInfo.registrationNum
                              if (vehicleInfo.vehicleType != null){
                                  this.setDriverCardParams.customized = vehicleInfo.vehicleType.name
                              }
                          }
                      }).catch(err =>{

                      })

                  } else {
                      console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
                      store.dispatch('InstallOrderServ_GetDetail',{
                          params:{
                              id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                          },
                          urlparams:null
                      }).then(res =>{
                          if (store.getters.get_InstallOrder_GetDetailResult){
                              let installOrder = store.getters.get_InstallOrder_GetDetailResult
                              this.setDriverCardParams.vin = installOrder.tempVehicleInfo.vin
                              this.setDriverCardParams.registrationNum = installOrder.tempVehicleInfo.registrationNum
                              if (installOrder.tempVehicleInfo.vehicleType != null){
                                  this.setDriverCardParams.customized = installOrder.tempVehicleInfo.vehicleType.name
                              }
                          }
                      }).catch(err =>{

                      })
                  }
              }
          }).catch(err =>{

          })
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.registrationNum = ''
      this.setDriverCardParams.vin = ''
      this.setDriverCardParams.vehicleType = ''
      this.setDriverCardParams.customized = ''
    },
    onSendDriverCardParams () {
      // console.log('99admin,' + this.setDriverCardParams.possword + ',SHTA' + this.setDriverCardParams.registrationNum + ',' + this.setDriverCardParams.vin + ',' + this.setDriverCardParams.vehicleType + ',' + this.setDriverCardParams.customized + '!')
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: '99admin,' + this.setDriverCardParams.possword + ',SHTA' + this.setDriverCardParams.registrationNum + ',' + this.setDriverCardParams.vin + ',' + this.setDriverCardParams.vehicleType + ',' + this.setDriverCardParams.customized + '!', urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    possworsOne(){
      this.setDriverCardParams.possword = 'admin'
    },
    posswordTwo(){
      this.setDriverCardParams.possword = 'JC336699'
    },
      passwordThree(){
          this.setDriverCardParams.possword = ''
      },
      passwordFour(){
          this.setDriverCardParams.possword = '870315'
      },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
